import AodObjectFactory from "../aodApi/object/AodObjectFactory";
import AodService from "../aodApi/AodService";
import model from "../model/models";
import {reject} from "lodash";
import axios from "axios";
import {notification} from "antd";
import {Wizard} from "./wizard";


// NOTE
// local test with https://local.metrocreativeconnection.com/
// which is mapped to localhost:3000 - on my laptop anyway -  by an apache vhost

export async function initStandAlone() {

    const {default: mcc} = await import("./mcc-api");
    const {mccLogin} = await import("./mccLogin");
    const mccAuth = new mcc.Auth(mccLogin.profile);
    const wizard = new Wizard({mccLogin, mccAuth});

    //NOTE z-* subdomains must be mapped in your own /etc/hosts
    // direct mapping should be http.  https can go through z-gateway (I think...)
    const aodService = new AodService({
        //baseURL: 'http://z-projects3.metrocreativeconnection.com:8080/rest'
        baseURL: 'https://projects3.metrocreativeconnection.com/rest'
    });

    //mcc.quarkRenderServer = "https://local.metrocreativeconnection.com:8443/";
    // XXX mcc.quarkRenderServer = "http://local.metrocreativeconnection.com:8000/";
    // XXX mcc.quarkRenderServer = "http://local-qr.metrocreativeconnection.com/";
    // XXX mcc.quarkRenderServer = "https://z-nodetest1.metrocreativeconnection.com:8443/";
    // Staging
    // mcc.quarkRenderServer = "https://z-projects3.metrocreativeconnection.com:8443/";
    mcc.quarkRenderServer = "https://api.metrocreativeconnection.com/test/qr/";
    //Live
    // mcc.quarkRenderServer = "https://api.metrocreativeconnection.com/qr/";

    //mcc.htmlToPdfServer = "http://local.metrocreativeconnection.com:8023/render/";
    //mcc.htmlToPdfServer = "https://local-html.metrocreativeconnection.com/render/";
    //mcc.htmlToPdfServer = "http://z-wkhtml2.metrocreativeconnection.com:8023/render2/";
    //Live
    mcc.htmlToPdfServer = "https://service.metrocreativeconnection.com/render2/";

    // default: mcc.setUrl('http://mcc.metrocreativeconnection.com/austin');
    //mcc.setUrl('http://z-mcc3.metrocreativeconnection.com:8088/austin');

    //const mccLoginUrl = 'https://mcg.metrocreativeconnection.com/metro/login';
    //const mccLoginUrl = 'http://z-mcg3.metrocreativeconnection.com/metro/login';


    return loadAodData({model, aodService})
        .then(() => {
            return {
                model,
                mcc,
                mccLogin,
                mccAuth,
                wizard,
                aodService,
                active: true,
                mccNav:{
                    infoView: asset=>notification.warning({description:'Info view: '+asset.file_base}),
                    clientView : view=>notification.warning({description:'Client view: '+view})
                }
            };
        });
}

export async function testMccLogin() {

    const {mccLogin} = await import("./mccLogin");
    const {user, password} = mccLogin;

    let formData = `httpd_username=${user}&httpd_password=${password}`;

    return axios({
        url: 'https://mcg.metrocreativeconnection.com/metro/login',
        method: 'post',
        data: formData,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
        }
    });
}

// Set up similar model data to the MCC client
// Just enough for the wizard to run outside the client
// Note this is storing some raw AOD data, not all UI aodItem objects as in MCC
export default async function loadAodData({model, aodService})
{
    const aodObjectFactory = new AodObjectFactory(aodService);
    const loginInfo = await aodService.loginInfo();

    // code from widget.js.  Note creates object
    //var loginAccount = new aod.Account(data);
    //model.account.replaceOne(this.name, loginAccount);

    const account = aodObjectFactory.get('Account', loginInfo.defaultAccount);
    model.account.replaceOne('selected_account', account);

    // todo -? make objects too
    // todo - RobP - this includes deleted advertisers
    model.advertiser.replace('selected_account', reject(loginInfo.defaultAccount.advertisers, 'deleted'));
    model.person.replace('selected_login', [loginInfo.person]);

    //const results = await aodService.submitRequest({
    //    queryPath: `publication/search/${loginInfo.defaultAccount.id}?view=expandedhierarchy`,
    //});
    // todo this unveified or tested
    //const results = await aodService.itemCalls['publication'].search(loginInfo.defaultAccount.id , '',{view:'expandedhierarchy'});

    //model.publication.replace('selected_account', results.publications);

    // test
    // ?-1 response
    //const results = await aodService.itemCalls['advertiser'].search(loginInfo.defaultAccount.id , '',{view:'full'});
    //console.log(results.advertisers);

    const personItem = aodService.itemCalls['person'];
    const results = await personItem.search(loginInfo.defaultAccount.id , 'account',{view:'full'});
    console.log(results.people);
    model.person.replace('account_person', personItem.getRecords(results));

    //const results = await aodService.itemCalls['account'].hierarchy(loginInfo.defaultAccount.id);
    //console.log(results);
}